<div class="aero-calendar-picker">

  <div class="bulb-input-label-wrapper">
    <label [for]="inputId"
         [ngClass]="{'bulb-required': required}">
      {{label}}
    </label>
    <span *ngIf="hintMessage"
        [ngClass]="{'bulb-hint-error-message': calendar.invalid && (calendar.dirty || calendar.touched)}"
        class="bulb-hint-message">
      {{hintMessage}}
    </span>
  </div>
  <p-datePicker [(ngModel)]="inputValue"
        ngDefaultControl
        [view]="pickerView"
        #calendar="ngModel" size="large"
        [showIcon]="showIcon" [iconDisplay]="'input'"
        [required]="required"
        [placeholder]="placeholder"
        [dateFormat]="dateFormat"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [disabled]="disabled"
        [focusTrap]="false"
        [keepInvalid]="true"
        [name]="name"
        (onBlur)="onBlur()"
        (ngModelChange)="updateChanges()"
        [readonlyInput]="readonlyInput"
        [inputId]="inputId">
    <ng-template #inputicon let-clickCallBack="clickCallBack">
      <i [ngClass]="calendarIcon" (click)="clickCallBack($event)"></i>
    </ng-template>
  </p-datePicker>
  <div class="bulb-error-wrapper">
    <span class="bulb-bottom-error-msg"
        *ngIf="calendar.invalid && (calendar.dirty || calendar.touched)">
      {{errorMessage}}
    </span>
  </div>

</div>
